import { Logger } from '../logger'
import { axiosSecure } from './api'

// Settings → CCC connection: the location's own body shop's CCC ONE Secure Share ID. Outside /v1/clients, so
// plans without the Clients feature (AI Brief) can still connect CCC. customErrorHandling: the card shows errors.

const logError = (method, error, params) => {
  Logger.error({ message: error, payload: { file: 'cccConnectionApi', method, params } })
}

/** GET /v1/ccc-connection?ccid= → { available, clientId, clientName, cccId, reason } */
export const getCccConnection = async (ccId) => {
  try {
    const response = await axiosSecure.get('/v1/ccc-connection', { params: { ccid: ccId }, customErrorHandling: true })
    return response?.data
  } catch (error) {
    logError('getCccConnection', error, { ccId })
    throw error
  }
}

/** PUT /v1/ccc-connection { ccid, ccc_id } — a blank id disconnects. Returns the same shape as GET. */
export const updateCccConnection = async (ccId, cccId) => {
  try {
    const response = await axiosSecure.put('/v1/ccc-connection', { ccid: ccId, ccc_id: cccId }, { customErrorHandling: true })
    return response?.data
  } catch (error) {
    logError('updateCccConnection', error, { ccId })
    throw error
  }
}
